import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { SensorSubmissionEntity } from './sensor-submission.entity';
import { SensorEntity } from './sensor.entity';

@Index('sensor_reading_sensor_idx', ['sensorId'])
@Entity('sensor_reading')
export class SensorReadingEntity extends BaseEntity {
	@Column('int', { name: 'fk_sensor__id', unsigned: true })
	public sensorId!: number;

	// --- Legacy columns (kept for backward compatibility, will be dropped after staging deploy) ---

	@Column('decimal', {
		name: 'fill_level',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public fillLevel!: number | null;

	@Column('decimal', {
		name: 'temperature',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public temperature!: number | null;

	@Column('decimal', {
		name: 'humidity',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public humidity!: number | null;

	@Column('int', { name: 'signal_strength', nullable: true })
	public signalStrength!: number | null;

	@Column('decimal', {
		name: 'battery_level',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public batteryLevel!: number | null;

	// --- Per-module fields (from sensor.modules[]) ---

	@Column('int', { name: 'distance', nullable: true })
	public distance!: number | null;

	@Column('decimal', {
		name: 'module_temperature',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public moduleTemperature!: number | null;

	@Column('smallint', { name: 'module_signal_strength', nullable: true })
	public moduleSignalStrength!: number | null;

	// --- Per-device fields (from status) ---

	@Column('smallint', {
		name: 'battery_voltage',
		unsigned: true,
		nullable: true,
	})
	public batteryVoltage!: number | null;

	@Column('decimal', {
		name: 'device_temperature',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public deviceTemperature!: number | null;

	@Column('int', { name: 'cellular_signal_strength', nullable: true })
	public cellularSignalStrength!: number | null;

	@Column('tinyint', { name: 'cellular_signal_quality', nullable: true })
	public cellularSignalQuality!: number | null;

	@Column('tinyint', { name: 'power_source', nullable: true })
	public powerSource!: number | null;

	// --- Submission FK ---

	@Column('int', {
		name: 'fk_sensor_submission__id',
		unsigned: true,
		nullable: true,
	})
	public submissionId!: number | null;

	// --- Relations ---

	@ManyToOne(() => SensorEntity)
	@JoinColumn({ name: 'fk_sensor__id' })
	public fkSensor!: SensorEntity;

	@ManyToOne(() => SensorSubmissionEntity)
	@JoinColumn({ name: 'fk_sensor_submission__id' })
	public fkSensorSubmission!: SensorSubmissionEntity;
}
